import {
  Button,
  Classes,
  FormGroup,
  H5,
  InputGroup,
  Popover,
} from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa } from "../../model";
import * as moment from "moment";
import { api } from "../../api";
import { AppStore } from "../../stores/AppStore";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import { toast } from "react-toastify";

interface CertificadoDialogProps {
}

interface CertificadoDialogState {
}

@observer
export default class CertificadoDialog
  extends React.Component<CertificadoDialogProps, CertificadoDialogState> {

  obs = observable({
    empresa: {} as IEmpresa,
    handleModalCertTeste: false as boolean,
    certificado: "" as string,
    senha_certificado: "" as string,
  })

  constructor(props) {
    super(props);
  }

  deletaCertificadoContador = () => {
    let resp = api.get(`/api/deleta-certificado-contabilidade`);
    toast.success('Certificado deletado com sucesso', {});
    window.location.reload();
  };
  uploadFileContador = (file: any) => {
    this.obs.certificado = file.target.files;
  };

  handleSave = () => {
    if (this.obs.certificado) {
      if (!this.obs.senha_certificado) {
        toast.error('Preencha a senha do certificado do contado', {});
        return;
      }
      PerfilStore.doSaveFileContador(this.obs.certificado, this.obs.senha_certificado);
    }
  };

  render() {
    let contaPermissao = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.conta.teste
      : false;

    return (
      <>
        <MDBCol md="12" className="offset-1">
          <MDBRow md="12">
            {AppStore.obs1.usuario.conta.certificado
              ? (
                <>
                  <h3 className="info-cert">
                    Certificado em uso. (Validade:{" "}
                    {moment(AppStore.obs1.usuario.conta.certificado).format(
                      "DD/MM/YYYY",
                    )})
                  </h3>
                  <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                    <Button intent="danger" icon="trash">
                      Excluir Certificado
                    </Button>
                    <div>
                      <H5>Confirmar exclusão?</H5>
                      <p>Atenção, deseja realmente excluir o certificado?</p>
                      <p>
                        Ao deletarexcluir, a FIPO não consultará mais os dados
                        da empresa juntamente ao SEFAZ.
                      </p>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: 15,
                        }}
                      >
                        <Button
                          className={Classes.POPOVER_DISMISS}
                          style={{ marginRight: 10 }}
                        >
                          Cancelar
                        </Button>
                        <Button
                          intent="danger"
                          className={Classes.POPOVER_DISMISS}
                          onClick={this.deletaCertificadoContador}
                        >
                          Excluir
                        </Button>
                      </div>
                    </div>
                  </Popover>
                </>
              )
              : contaPermissao
                ? (
                  <>
                    Gostaria de cadastrar o certificado digital? Clique abaixo e
                    entenda como funciona! <br />
                    <Button
                      onClick={(e) => this.obs.handleModalCertTeste = true}
                      className="certiDigitalTeste"
                    >
                      Certificado Digital
                    </Button>
                  </>
                )
                : (
                  <>
                    <MDBCol md="7">
                      <h2 className="title">Certificado Digital (A1) Contador</h2>

                      <FormGroup
                        label="Selecionar Certificado Digital Contador"
                        labelFor="certificado"
                      >
                        <input
                          type="file"
                          id="Certificado"
                          className="CertificadoFile"
                          name="file"
                          onChange={(e) => this.uploadFileContador(e)}
                        />
                      </FormGroup>

                      <FormGroup
                        label="Senha Certificado"
                        labelFor="senha_certificado_contador"
                      >
                        <InputGroup
                          id="senha_certificado_contador"
                          type="password"
                          onChange={(e: any) => this.obs.senha_certificado = e.target.value}
                          name='new-password'
                          autoComplete='new-password'
                        />
                      </FormGroup>

                      <div className="nz-button-panel">
                        <Button intent="primary" onClick={this.handleSave}>
                          Salvar Certificado
                        </Button>
                      </div>

                    </MDBCol>
                  </>
                )}
          </MDBRow>
        </MDBCol>
        <MDBCol>
        </MDBCol>
      </>
    );
  }
}
